import OkC from "shared/util/OkcApi";

/**
 * Endpoint to mark experiments.
 * @param {Array} experiments - A list of experiments to mark.
 * @returns {Promise} - returns a promise.
 */
export function markExperiments(experiments) {
	return OkC.post("/experiments/mark", {
		api: 1,
		data: {
			experiments,
		}
	});
}



// WEBPACK FOOTER //
// ./src/shared/util/Experiment.js